import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';

import CardSimilares from 'components/CardSimilares';

import { SimilaresContainer } from './similares-styled';

const AnunciosSimilares = ({ similares, isUserAuthenticated }) => {
    return (
        <SimilaresContainer>
            <Swiper
                breakpoints={{
                    320: {
                        slidesPerView: 1.15,
                        spaceBetween: 10,
                        slidesPerGroup: 1,
                        allowTouchMove: true,
                    },
                    375: {
                        slidesPerView: 1.15,
                        spaceBetween: 0,
                        slidesPerGroup: 1,
                        allowTouchMove: true,
                    },
                    425: {
                        slidesPerView: 1.3,
                        spaceBetween: 0,
                        slidesPerGroup: 1,
                        allowTouchMove: true,
                    },
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 3,
                        slidesPerGroup: 2,
                        allowTouchMove: false,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 3,
                        slidesPerGroup: 3,
                        allowTouchMove: false,
                    },
                    1250: {
                        slidesPerView: 3,
                        spaceBetween: -40,
                        slidesPerGroup: 3,
                        allowTouchMove: false,
                    },
                }}
                pagination={true}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >
                {similares &&
                    similares.map((item) => (
                        <SwiperSlide key={item.id}>
                            <CardSimilares
                                key={item.id}
                                similaresId={item.id}
                                isUserAuthenticated={isUserAuthenticated}
                                {...item}
                            />
                        </SwiperSlide>
                    ))}
            </Swiper>
        </SimilaresContainer>
    );
};

export default AnunciosSimilares;
